// extracted by mini-css-extract-plugin
export default {"bannerImage":"BannerImage_bannerImage__U6wgz","skeleton":"BannerImage_skeleton__fIUMj","skeletonBannerImage":"BannerImage_skeletonBannerImage__qlsU4"};